export default __webpack_public_path__ + "static/media/filter_calendar_light.f10716f8.svg";